import { nft5pool } from "../../../../../configure";

const tokens = {
  4: {},
  3: {},
  1: {}

};

nft5pool.map(({chainId, token, tokenAddress })=> {
  tokens[chainId][token] = {
    tokenAddress: tokenAddress,
    tokenBalance: 0
  }
  tokens[chainId] = {
    tokenBalance: 0
  }
  return '';
})

// console.log(tokens)

const initialState = {
  nft5pool,
  tokens,
};

export default initialState;